<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 84.812 50.877"
  >
    <path
      id="Icon_awesome-motorcycle"
      data-name="Icon awesome-motorcycle"
      d="M67.956,21.459a16.764,16.764,0,0,0-5.618.914L57.98,15.1H68.9a3.172,3.172,0,0,0,3.18-3.18V7.68A3.172,3.172,0,0,0,68.9,4.5h-6a3.18,3.18,0,0,0-2.358,1.047l-4.968,5.525L52.547,6.037A3.2,3.2,0,0,0,49.818,4.5h-10.6A2.126,2.126,0,0,0,37.1,6.62V8.74a2.126,2.126,0,0,0,2.12,2.12h8.8L50.56,15.1H30.2c-2.345-3.061-5.949-5.3-13.236-5.3H9.608a3.226,3.226,0,0,0-3.246,3.246,3.176,3.176,0,0,0,3.18,3.114h7.419a7.016,7.016,0,0,1,6.333,3.286l-1.5,2.716a16.958,16.958,0,1,0,11.593,20.5H44.545a3.181,3.181,0,0,0,3.18-3.325A20.069,20.069,0,0,1,55.171,22.77l1.656,2.756a16.962,16.962,0,1,0,11.129-4.067Zm-51,27.558a10.6,10.6,0,1,1,0-21.2,9.857,9.857,0,0,1,1.656.132l-5.5,9.99A3.184,3.184,0,0,0,15.9,42.657H26.672A10.628,10.628,0,0,1,16.961,49.017ZM78.423,39a10.6,10.6,0,0,1-21.185-.583,10.513,10.513,0,0,1,2.928-7.3l6.545,10.917a2.129,2.129,0,0,0,2.915.729l1.815-1.086a2.129,2.129,0,0,0,.729-2.915L65.73,28.043a10.147,10.147,0,0,1,2.107-.212A10.6,10.6,0,0,1,78.423,39Z"
      transform="translate(0.002 -4.5)"
      fill="#2f3042"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-20'
    },
    height: {
      type: String,
      default: 'h-12'
    }
  }
}
</script>
